export const PLAYER = {
  PLAY: 'action/player/play',
  PAUSE: 'action/player/pause',
  SET_VOLUME: 'action/player/set-volume',
  ENTER_FULLSCREEN: 'action/player/enter-fullscreen',
  EXIT_FULLSCREEN: 'action/player/exit-fullscreen',
}
